export const LogoMark = ({ size = 32, className = "", bare = false }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    {!bare && <rect width="64" height="64" rx="16" fill="#1C2B4A" />}
    <circle cx="32" cy="32" r="15" fill="none" stroke="#FAF7F2" strokeWidth="6" />
    <circle cx="44.5" cy="19.5" r="6" fill="#E9DCC3" />
  </svg>
);

export const Logo = ({ testId = "header-logo" }) => (
  <a href="/" data-testid={testId} className="group inline-flex items-center gap-2.5" aria-label="Otti home">
    <LogoMark size={34} className="transition-transform duration-500 group-hover:rotate-[-12deg]" />
    <span className="font-display text-2xl font-medium tracking-tight text-[#16203A]">otti</span>
  </a>
);
